export default {"src":"/_next/static/media/search-icon.106e3425.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};